import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./it.json";
import en from "./en.json";
import thankyou_it from "./thankyou_it.json";

export const SUPPORTED_LANGUAGES = ["it", "en"];
export const DEFAULT_LANGUAGE = "it";

i18n.use(initReactI18next).init({
    resources: {
        it: { translation: it, thankyou: thankyou_it },
        en: { translation: en, thankyou: thankyou_it },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
